import { color, Color } from '@amcharts/amcharts5';

export enum ChartThemeEnum {
  LIGHT = 'LIGHT',
  DARK = 'DARK',
}

export class ChartThemeEnumUtil {
  public static gradientCurrentColor(
    chartTheme: ChartThemeEnum,
  ): Color {
    let colorVar: Color | undefined;
    switch (chartTheme) {
      case ChartThemeEnum.DARK:
        colorVar = color(0x000000);
        break;
      case ChartThemeEnum.LIGHT:
        colorVar = color(0xeeeeee);
        break;
    }
    return colorVar;
  }
  public static gradientCompareColor(
    chartTheme: ChartThemeEnum,
  ): Color {
    let colorVar: Color | undefined;
    switch (chartTheme) {
      case ChartThemeEnum.DARK:
        colorVar = color(0x222222);
        break;
      case ChartThemeEnum.LIGHT:
        colorVar = color(0xbbbbbb);
        break;
    }
    return colorVar;
  }
  public static bgColor(
    chartTheme: ChartThemeEnum,
  ): Color {
    let colorVar: Color | undefined;
    switch (chartTheme) {
      case ChartThemeEnum.DARK:
        colorVar = color(0x000000);
        break;
      case ChartThemeEnum.LIGHT:
        colorVar = color(0xFFFFFF);
        break;
    }
    return colorVar;
  }
  public static fgColor(
    chartTheme: ChartThemeEnum,
  ): Color {
    let colorVar: Color | undefined;
    switch (chartTheme) {
      case ChartThemeEnum.DARK:
        colorVar = color(0xFFFFFF);
        break;
      case ChartThemeEnum.LIGHT:
        colorVar = color(0x000000);
        break;
    }
    return colorVar;
  }
  public static fgColor2(
    chartTheme: ChartThemeEnum,
  ): Color {
    let colorVar: Color | undefined;
    switch (chartTheme) {
      case ChartThemeEnum.DARK:
        colorVar = color(0xd0d5dd);
        break;
      case ChartThemeEnum.LIGHT:
        colorVar = color(0x7C8089);
        break;
    }
    return colorVar;
  }
  public static fgColor3(
    chartTheme: ChartThemeEnum,
  ): Color {
    let colorVar: Color | undefined;
    switch (chartTheme) {
      case ChartThemeEnum.DARK:
        colorVar = color(0xFFFFFF);
        break;
      case ChartThemeEnum.LIGHT:
        colorVar = color(0x7C8089);
        break;
    }
    return colorVar;
  }
}
